import { SeverityClassification } from '@portals/shared/admin/ApiDto';

export const SERVICE_NOW_INFO_FORM_ID = 'ServiceNowInfoForm';

export const SEVERITY_CLASSIFICATION_OPTIONS: Record<SeverityClassification, string> = {
  [SeverityClassification.OPEN]: 'Open',
  [SeverityClassification.INTERNAL]: 'Internal',
  [SeverityClassification.CONFIDENTIAL]: 'Confidential',
  [SeverityClassification.STRICTLY_CONFIDENTIAL]: 'Strictly Confidential',
};
